// project-imports
import pages from './pages';

// The sidebar's sections. Items keep their definitions (permission, module,
// url) in pages.jsx; this only decides which heading each one sits under.
const SECTIONS = [
  { id: 'overview', caption: 'Overview', items: ['dashboard'] },
  {
    id: 'operations',
    caption: 'Operations',
    items: ['booking-management', 'calendar', 'giftcard', 'ticket', 'vouchers', 'loyalty', 'menus', 'pos-setup', 'store-room']
  },
  { id: 'people', caption: 'People', items: ['restaurant', 'user', 'roles-permissions'] },
  { id: 'admin', caption: 'Admin', items: ['settings', 'facilities-preference', 'custom-setup'] }
];

const byId = Object.fromEntries(pages.children.map((item) => [item.id, item]));
const placed = new Set(SECTIONS.flatMap((section) => section.items));
// Anything added to pages.jsx without a section still shows, under the last one.
const unplaced = pages.children.filter((item) => !placed.has(item.id));

const groups = SECTIONS.map((section, index) => ({
  id: section.id,
  title: section.caption,
  caption: section.caption,
  type: 'group',
  children: [...section.items.map((id) => byId[id]).filter(Boolean), ...(index === SECTIONS.length - 1 ? unplaced : [])]
}));

const menuItems = {
  items: groups
};

export default menuItems;
